module.exports = __webpack_public_path__ + "static/media/dev-work.6ed90e75.jpg";